import React from 'react'
import { useFormikContext } from 'formik'
import { rationalNumbers } from 'Core/masks'

import { TextInputNew, Wrapper } from 'SRC/ui/FormElementsNew'

export const BuyPrice = () => {
	const formik = useFormikContext()

	const error = formik.touched.price && formik.errors.price

	return (
		<Wrapper isError={error}>
			<TextInputNew
				id='buyPrice'
				name='buyPrice'
				title='Maksimana cijena koju želite platiti'
				value={formik.values.price}
				mask={rationalNumbers}
				measure='€'
				onChange={async textValue => {
					console.log('buyprice', textValue)
					await formik.setFieldValue('price', textValue, false)

					if (!formik.touched.price) formik.setFieldTouched('price', true)

					formik.setErrors({
						...formik.errors,
						price: formik.touched.price && [0, -1].includes(Number(textValue)) ? 'Popunite cijenu' : undefined
					})
				}}
			/>
		</Wrapper>
	)
}